import React from "react"
import { Col, ControlLabel, FormControl, FormGroup, HelpBlock } from "react-bootstrap"

export default function FormControlInlineTextArea({ controlId, validationState, label, placeholder, value,
onChange, helpText, className }) {

  return (
    <FormGroup controlId={ controlId } validationState={ validationState }>

      <Col componentClass={ ControlLabel } sm={4}>
        { label }
      </Col>

      <Col sm={8}>
        <FormControl componentClass="textarea" placeholder={ placeholder }
          value={ value } className={ className } id={ controlId }
          onChange={e => onChange(e.target.value)}
        />
        <FormControl.Feedback />
        <HelpBlock>{ helpText }</HelpBlock>
      </Col>
    </FormGroup>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/FormControl.Inline.TextArea.js